module.exports = __webpack_public_path__ + "img/freelancer_thumbnail-400x300.67378b9a.jpg";